import CampaignCameraIcon from "~/components/icons/CampaignCameraIcon";

interface CampaignCardHeaderProps {
  title: string | null;
  subtitle: string | null;
}

const CampaignCardHeader = ({ title, subtitle }: CampaignCardHeaderProps) => (
  <div className="campaign-card__header">
    <h2 className="campaign-card__title">
      <CampaignCameraIcon className="campaign-card__header-icon" /> {title}
    </h2>
    <p className="campaign-card__subtitle">{subtitle}</p>
  </div>
);

export default CampaignCardHeader;
